import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";
import LoadingSpinner from "./LoadingSpinner";

function PrivateRoute({ allowedRoles, children }) {
  const { isAuthenticated, role, isInitialized, isLoading } = useAuth();

  // Show loading while authentication is being initialized
  if (!isInitialized || isLoading) {
    return <LoadingSpinner message="Verificando autenticación..." />;
  }

  // Si no está autenticado, redireccionamos al inicio
  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  // Verificamos si el rol del usuario está en la lista de roles permitidos
  if (!allowedRoles.includes(role)) {
    // Si no, podría redireccionar a 404, o a una página de "No autorizado"
    return <Navigate to="/" />;
  }

  return children; // Renderiza la ruta protegida si pasa la verificación
}

export default PrivateRoute;
